import { useCallback, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { IApiCallStatus, useAlertContext } from '../common';
import { left, right, map } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/lib/function';

export function useMigrationTimeout(apiCallStatus: IApiCallStatus) {
  const { setAlert } = useAlertContext();

  const timerRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    flow(
      apiCallStatus =>
        apiCallStatus === null ? right(apiCallStatus) : left(apiCallStatus),
      map(
        () =>
          (timerRef.current = setTimeout(() => {
            setAlert(a => ({
              ...a,
              title: 'CSOS Sign In',
              message: () => (
                <>
                  <FontAwesomeIcon icon={faSpinner} size="1x" fixedWidth spin />{' '}
                  Please wait for your profile migration.
                </>
              ),
              okAction: false,
              cancelAction: false,
              isOpen: true,
            }));
          }, profileMigrationTimeout))
      )
    )(apiCallStatus);
  }, [apiCallStatus, setAlert]);

  const clear = useCallback(
    () => timerRef.current && clearTimeout(timerRef.current),
    []
  );

  return clear;
}

const profileMigrationTimeout = 30000;
